import { render, staticRenderFns } from "./tableFieldModal.vue?vue&type=template&id=31ae2857&scoped=true"
import script from "./tableFieldModal.vue?vue&type=script&lang=js"
export * from "./tableFieldModal.vue?vue&type=script&lang=js"
import style0 from "./tableFieldModal.vue?vue&type=style&index=0&id=31ae2857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae2857",
  null
  
)

export default component.exports